import { ForecastLiteral } from "@sports-utils/sports.constants";
import { CombinationMulticastInput, RaceLineItem, StraightMulticastInput } from "../models";

enum MaxSystem {
  Forecast = 3,
  Tricast = 1,
}

export const createCombinationMulticastResult = (combinationData, resultIds): CombinationMulticastInput => ({
  ClientData: "",
  Event: combinationData.Event,
  Game: {
    Id: combinationData.Game.Id,
    GameTypeId: combinationData.Game.GameTypeId,
    SpecialOddsValue: combinationData.Game.SpecialOddsValue,
    IsInPlay: false,
    BetTypeAvailability: 0,
    NumberOfStarters: combinationData.Game.NumberOfStarters,
    PlaceOddsDivisor: 0,
    IncludedPlaces: 0,
  },
  League: combinationData.League,
  Location: combinationData.Location,
  Magnitude: combinationData.Magnitude,
  MaxSystem: combinationData.Magnitude === 2 ? MaxSystem.Forecast : MaxSystem.Tricast, // defaults: Forecast=3, Tricast=1, Others=No Limit
  PlacementSource: "",
  ResultIds: resultIds,
  Sport: combinationData.Sport,
  TaxSettings: "",
});

export const createStraightMulticastResult = (straightData, arrResults): StraightMulticastInput => ({
  ClientData: "",
  Event: straightData.Event,
  Game: {
    Id: straightData.Game.Id,
    GameTypeId: straightData.Game.GameTypeId,
    SpecialOddsValue: straightData.Game.GameSpecialOddsValue,
    IsInPlay: false,
    BetTypeAvailability: straightData.Game.GameBetTypeAvailability,
    NumberOfStarters: straightData.Game.NumberOfStarters,
    PlaceOddsDivisor: 0,
    IncludedPlaces: 0,
  },
  League: straightData.League,
  Location: straightData.Location,
  MaxSystem: straightData.Magnitude === 2 ? MaxSystem.Forecast : MaxSystem.Tricast, // defaults: Forecast=3, Tricast=1, Others=No Limit
  PlacementSource: "",
  Results: arrResults,
  Sport: straightData.Sport,
  TaxSettings: "",
});

export const createLineItemFromRace = (raceData, sortedArray): RaceLineItem => {
  const milliseconds = raceData.StartDate.replace("/Date(", "").replace(")/", "");
  const date = new Date(+milliseconds);
  return {
    Amount: raceData.Amount || 0,
    AmountLocal: raceData.AmountLocal || 0,
    CanBeEachWay: raceData.CanBeEachWay || false,
    downOdd: false,
    EventDate: raceData.StartDate,
    EventHasHandicap: raceData.HasHandicap,
    EventName: `${date.getHours().toString()}:${(date.getMinutes() < 10 ? "0" : "") + date.getMinutes().toString()} ${raceData.PaddockName}`, // must
    GameBetTypeAvailability: raceData.GameBetTypeAvailability,
    GameId: raceData.GameId,
    GameLocked: raceData.GameLocked || false,
    GameName: getGame(sortedArray), // raceData.betType === 'Forecast' ? 'Gemela' : 'Trío', // must be Gemela / Trío, / Etc.
    GameSpecialOddsValue: raceData.GameSpecialOddsValue,
    GreyhoundHorseBetType: raceData.GreyhoundHorseBetType || undefined,
    GreyhoundHorses: true,
    Handicap: raceData.HasHandicap,
    Index: raceData.Index,
    IsBanked: false,
    IsBet: !!raceData.IsBet,
    IsLive: false,
    ItemId: null,
    LineErrorMessages: [],
    LineErrors: null,
    LineItemStatus: 0,
    LiveStatus: false,
    Name: "Name",
    NodeId: raceData.NodeId,
    NotAvailable: false,
    Odd: raceData.Odd,
    Paddock: raceData.PaddockName,
    Participants: sortedArray.arrBet,
    PendingCheck: raceData.PendingCheck,
    PipelineExecutionResult: raceData.PipelineExecutionResult || 0,
    Place: raceData.Place,
    ResultName: extractName(sortedArray),
    ResultsNr: "",
    Selected: false,
    SpecialOddsValue: raceData.SpecialOddsValue,
    SportHandle: raceData.SportHandle,
    TicketNumber: raceData.TicketNumber || null,
    TotalPotentialWin: raceData.TotalPotentialWin || 0,
    upOdd: false,
  };
};

const getGame = (data): string => {
  const comb = !data.ordered;

  return comb
    ? data.betType === ForecastLiteral
      ? "tTwinC"
      : "tTrioC"
    : data.betType === ForecastLiteral
      ? "tTwin"
      : "tTrio";
};

const extractName = (data): string => {
  let sum = "";
  data.arrBet.map(
    (item, i) => (sum += (i ? ", " : "") + (item.order === -1 ? item.Name : item.order + "º " + item.Name)),
  );
  return sum.trim();
};

export function handleError(state, error) {
  const auxState = JSON.parse(JSON.stringify(state));
  auxState.ticket.isPlacingbet = false;
  auxState.ticket.processing = false;
  auxState.processingFrom = "";
  console.error(error);
  const newState = Object.assign({}, state, {
    ticket: auxState.ticket,
  });
  return newState;
}

// REDUCER Utils
export const findErrorCode = (existItemId) => {
  const errorCodes = ["ST_SBS_CalculationBaseReferenceEventNodeNotActive"];
  const errorCodeFound = errorCodes.find((i) => i === existItemId.ErrorCode);
  return errorCodeFound;
};
